import wrapPage from './wrap-page-element';
import './src/styles/global.css';

export const wrapPageElement = wrapPage
